import {
    Box,
    CrudMode,
    DataDisplay,
    Grid,
    pn,
    Stack,
    Typography,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { Cohort, CohortEditResource, CohortViewResource } from "generated/openApi";
import produce from "immer";
import React from "react";

export const CohortPageBody = (props: {
    crudMode: CrudMode;
    cohort: Cohort;
    setCohort: (value: Cohort) => void;
    viewResource: CohortViewResource;
    editResource: CohortEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<Cohort>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.cohort.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.cohort.name}
                onChange={(e) =>
                    props.setCohort(
                        produce(props.cohort, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};
